

module.exports = __webpack_require__.stylable.create(
    "Checkbox1233646382",
    {"classes":{"root":"Checkbox1233646382__root","label":"Checkbox1233646382__label","labelInner":"Checkbox1233646382__labelInner","children":"Checkbox1233646382__children","checkbox":"Checkbox1233646382__checkbox","inner":"Checkbox1233646382__inner","outer":"Checkbox1233646382__outer"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "Checkbox1233646382",
    null
);
